/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDRequestMetadata
 */
export interface IDRequestMetadata {
    /**
     * 
     * @type {string}
     * @memberof IDRequestMetadata
     */
    pkce_code_challenge?: string;
    /**
     * 
     * @type {string}
     * @memberof IDRequestMetadata
     */
    csrf_token?: string;
}

/**
 * Check if a given object implements the IDRequestMetadata interface.
 */
export function instanceOfIDRequestMetadata(value: object): value is IDRequestMetadata {
    return true;
}

export function IDRequestMetadataFromJSON(json: any): IDRequestMetadata {
    return IDRequestMetadataFromJSONTyped(json, false);
}

export function IDRequestMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDRequestMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'pkce_code_challenge': json['pkce_code_challenge'] == null ? undefined : json['pkce_code_challenge'],
        'csrf_token': json['csrf_token'] == null ? undefined : json['csrf_token'],
    };
}

export function IDRequestMetadataToJSON(json: any): IDRequestMetadata {
    return IDRequestMetadataToJSONTyped(json, false);
}

export function IDRequestMetadataToJSONTyped(value?: IDRequestMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pkce_code_challenge': value['pkce_code_challenge'],
        'csrf_token': value['csrf_token'],
    };
}

